import type { TOC } from '@ember/component/template-only'
import { t } from 'ember-intl'
import type { PageMeta } from 'district-ui-client/components/base/page-controls'

interface PageSummarySignature {
  Element: HTMLDivElement
  Args: {
    meta: PageMeta
  }
}

const calcFrom = ({ page_number, page_size, total_entries }: PageMeta) => {
  return total_entries === 0 ? 0 : (page_number - 1) * page_size + 1
}

const calcTo = ({ page_number, page_size, total_entries }: PageMeta) => {
  return Math.min(page_number * page_size, total_entries)
}

export const PageSummary: TOC<PageSummarySignature> = <template>
  <div class="text-sm text-neutral-250">
    {{t "base.pageSummary.text" from=(calcFrom @meta) to=(calcTo @meta) totalCount=@meta.total_entries}}
  </div>
</template>
